import { ca } from '@cian/analytics';

import { type IDeveloperFactWebSchema } from 'shared/repositories/special-promos/entities/developer_fact_web/DeveloperFactWebSchema';

/**
 * @description Событие: блок с фактами попал в зону видимости.
 */
export function trackShowFactsSection(facts: IDeveloperFactWebSchema[]): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'facts',
    name: 'oldevent',
    products: facts.map((fact, index) => ({
      id: fact.type,
      offerType: 'type',
      position: index,
    })),
  });
}
